import {getEventTitle} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import classNames from 'classnames'
import React from 'react'
import {useSettings} from '../../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../../settingsParams'
import {useAppSelector} from '../../../../hooks/runtime'
import {getEvent} from '../../../../selectors/event'
import {TitleProps} from './interfaces'
import {classes} from './title.st.css'

export const Title: React.FC<TitleProps> = ({className}) => {
  const settings = useSettings()

  const event = useAppSelector(getEvent)
  const titleTag = settings.get(settingsParams.titleTag) as string

  return (
    <Text className={classNames(className, classes.title)} data-hook={DH.headerEventTitle} tagName={titleTag}>
      {getEventTitle(event)}
    </Text>
  )
}
